import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}",{ moduleName: "adcdriver/templates/application.hbs" })